<template>
  <transition name="slide-fade">
    <div
      v-if="showNotifications && !hidden"
      class="notify-box"
      :class="notificationTone"
      role="status"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="notify-inner">
        <template v-if="event.type === 'App\\Notifications\\SororityWarsSlap'">
          <Slapped @closeMe="closeMe" :notif="event" />
        </template>
        <template v-else-if="event.type === 'App\\Notifications\\AttackAction'">
          <Attacking @closeMe="closeMe" :notif="event" />
        </template>
        <template v-else-if="event.type === 'App\\Notifications\\SororityWarsHouseAction'">
          <Invites @closeMe="closeMe" :notif="event" />
        </template>
        <template v-else-if="event.type === 'App\\Notifications\\HouseActionNoFeed'">
          <Invites @closeMe="closeMe" :notif="event" />
        </template>
        <template v-else-if="event.type === 'App\\Notifications\\WhiteboardComment'">
          <Whiteboard @closeMe="closeMe" :notif="event" />
        </template>
        <template v-else-if="event.type === 'App\\Notifications\\HouseMassAddSuccess'">
          <MassAddSuccess @closeMe="closeMe" :notif="event" />
        </template>
        <template v-else-if="event.type === 'App\\Notifications\\UserListedPlayer'">
          <BurnList @closeMe="closeMe" :notif="event" />
        </template>
        <template v-else-if="event.type === 'App\\Notifications\\UserExecutedHit'">
          <BurnListExecute @closeMe="closeMe" :notif="event" />
        </template>
        <template v-else-if="event.type === 'App\\Notifications\\UserDied'">
          <Died @closeMe="closeMe" :notif="event" />
        </template>
      </div>
      <div class="notify-progress" aria-hidden="true"><span /></div>
    </div>
  </transition>
</template>

<script>
import Slapped from '@/components/notifs/Slapped'
import Died from '@/components/notifs/Died'
import BurnList from '@/components/notifs/BurnList'
import BurnListExecute from '@/components/notifs/BurnListExecute'
import Attacking from '@/components/notifs/Attacking'
import Invites from '@/components/notifs/Invites'
import Whiteboard from '@/components/notifs/Whiteboard'
import MassAddSuccess from '@/components/notifs/MassAddSuccess'
export default {
  name: 'NotificationBase',
  components: { MassAddSuccess, Slapped, Invites, Whiteboard, Attacking, BurnList, Died, BurnListExecute },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    showNotifications () {
      return this.$store.state.user.iNotifications
    },
    notificationTone () {
      const blueNotifications = [
        'App\\Notifications\\SororityWarsHouseAction',
        'App\\Notifications\\HouseActionNoFeed',
        'App\\Notifications\\WhiteboardComment',
        'App\\Notifications\\HouseMassAddSuccess'
      ]
      return blueNotifications.includes(this.event.type)
        ? 'notify-box--blue'
        : 'notify-box--pink'
    }
  },
  data () {
    return {
      hidden: false,
      dismissTimer: null
    }
  },
  created () {
    this.dismissTimer = setTimeout(() => {
      this.hidden = true
    }, 5000)
  },
  beforeDestroy () {
    if (this.dismissTimer) clearTimeout(this.dismissTimer)
  },
  methods: {
    closeMe () {
      if (this.dismissTimer) clearTimeout(this.dismissTimer)
      this.hidden = true
    }
  }
}
</script>

<style>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: transform 300ms ease, opacity 300ms ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(16px);
  opacity: 0;
}

.notify-placement {
  position: fixed;
  z-index: 9999;
  right: 20px;
  bottom: 15px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 5px;
  pointer-events: none;
}

.notify-box {
  position: relative;
  box-sizing: border-box;
  width: 264px;
  min-height: 68px;
  overflow: hidden;
  padding: 7px 7px 9px;
  color: #000;
  background: #fff;
  border: 2px solid #e84063;
  border-radius: 8px;
  box-shadow: 0 5px 16px rgba(14, 85, 119, 0.24);
  pointer-events: auto;
}

.notify-box--blue {
  border-color: #238cbd;
}

.notify-inner {
  position: relative;
  min-width: 0;
}

.notify-inner > div {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.notify-left {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
  background: #fff3f6;
  border: 1px solid rgba(232, 64, 99, 0.38);
  border-radius: 7px;
  text-align: center;
}

.notify-box--blue .notify-left {
  background: #eef9fc;
  border-color: rgba(35, 140, 189, 0.42);
}

.notify-right {
  position: relative;
  min-width: 0;
  flex: 1 1 auto;
  padding-right: 22px;
  text-align: left;
}

.notify-inner > .notify-right {
  min-height: 46px;
  padding: 3px 22px 3px 4px;
}

.notify-others {
  color: #5f6870;
  font-size: 11px;
  font-style: italic;
}

.notify-close {
  position: absolute;
  z-index: 1;
  top: -3px;
  right: -3px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 23px;
  height: 23px;
  padding: 0;
  color: #ad1f51;
  background: #fff;
  border: 1px solid rgba(232, 64, 99, 0.45);
  border-radius: 50%;
  font-family: inherit;
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
}

.notify-box--blue .notify-close {
  color: #0b5aa8;
  border-color: rgba(35, 140, 189, 0.5);
}

.notify-close:hover {
  color: #fff;
  background: #e84063;
}

.notify-box--blue .notify-close:hover {
  background: #238cbd;
}

.notify-close:focus {
  outline: 2px solid rgba(11, 90, 168, 0.35);
  outline-offset: 1px;
}

.notify-alert {
  margin-bottom: 2px;
  color: #ad1f51;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.05em;
  line-height: 1.1;
  text-align: left;
  text-transform: uppercase;
}

.notify-box--blue .notify-alert {
  color: #0b5aa8;
}

.notify-title {
  color: #15232c;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
  text-align: left;
}

.notify-title a {
  font-weight: 900;
}

.notify-title a:hover {
  text-decoration: underline;
}

.notify-progress {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  overflow: hidden;
  background: rgba(232, 64, 99, 0.12);
}

.notify-progress span {
  display: block;
  width: 100%;
  height: 100%;
  background: #e84063;
  transform-origin: left center;
  animation: notify-countdown 5s linear forwards;
}

.notify-box--blue .notify-progress {
  background: rgba(35, 140, 189, 0.14);
}

.notify-box--blue .notify-progress span {
  background: #238cbd;
}

.notify-image {
  display: none;
}

@keyframes notify-countdown {
  from {
    transform: scaleX(1);
  }

  to {
    transform: scaleX(0);
  }
}

@media only screen and (max-width: 768px) {
  .notify-placement {
    right: max(10px, env(safe-area-inset-right));
    bottom: max(10px, env(safe-area-inset-bottom));
    gap: 5px;
  }

  .notify-box {
    width: 48px;
    min-height: 48px;
    height: 48px;
    padding: 3px 3px 5px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(14, 85, 119, 0.28);
  }

  .notify-inner,
  .notify-inner > div {
    width: 100%;
    height: 100%;
  }

  .notify-inner > div {
    display: block;
  }

  .notify-left,
  .notify-right,
  .desktop-notify-image {
    display: none;
  }

  .notify-inner > div > .notify-image {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .notify-inner > div > img.notify-image,
  .notify-inner > div > .notify-image img.notify-image {
    display: block;
    width: 38px;
    height: 38px;
    object-fit: contain;
  }

  .notify-progress {
    height: 2px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: none;
  }

  .notify-progress span {
    animation: none;
  }
}
</style>
